import { defineStore } from 'pinia';
import { UserInfo } from '@/app/user-info';

export const useUserStore = defineStore('user', {
  state: () => ({
    info: null as UserInfo | null,
    failedGettingInfo: false,
  }),
});
